import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=b5e4a6e6&scoped=true&"
import script from "./SearchFilters.vue?vue&type=script&lang=ts&"
export * from "./SearchFilters.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFilters.vue?vue&type=style&index=0&id=b5e4a6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e4a6e6",
  null
  
)

export default component.exports